import React from 'react'
import { Form, InputGroup, Row, Col } from 'react-bootstrap'
import { getDefaultAuxiliaryLine, nullishValueToValue, nullishValueToInternalValue } from '../ArticleParse'
import type { Layoutable } from '../types'
import type { PriorityValue } from '../../common/types'

type MutableAuxiliaryLine = {
  startColumn?: number | string | null
  startRow?: number | string | null
  length?: number | string
}

type FormAuxiliaryLine = {
  startColumn?: number | null
  startRow?: number | null
  length?: number
}

type FormAuxiliaryLineErrors = { startColumn?: string; startRow?: string; length?: string }
type FormAuxiliaryLineTouched = { startColumn?: boolean; startRow?: boolean; length?: boolean }

type Values = {
  useAuxiliaryLine: boolean
  auxiliaryLine?: FormAuxiliaryLine | null
  priority: PriorityValue
}

type Errors = {
  useAuxiliaryLine?: string
  auxiliaryLine?: FormAuxiliaryLineErrors
}

type Touched = {
  useAuxiliaryLine?: boolean
  auxiliaryLine?: FormAuxiliaryLineTouched
}

type Props = {
  values: Values
  errors: Errors
  touched: Touched
  setFieldValue: (field: string, value: unknown) => void
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  layoutable: Layoutable
}

export const AuxiliaryLineFields = ({
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  handleBlur,
  layoutable
}: Props) => {
  return (
    <Row className='mb-2'>
      <Form.Group as={Col}>
        <Form.Label column>補助線</Form.Label>
        <Row>
          <Form.Group as={Col} sm='auto'>
            <Form.Check
              type='switch'
              id='useAuxiliaryLineSwitch'
              label='補助線あり'
              name='useAuxiliaryLine'
              checked={values.useAuxiliaryLine}
              onChange={(e) => {
                const useAuxiliaryLine = e.target.checked
                if (useAuxiliaryLine && values.auxiliaryLine === null) {
                  const auxiliaryLine = getDefaultAuxiliaryLine({
                    layoutable,
                    priority: values.priority
                  })
                  console.log('auxiliaryLine', auxiliaryLine)
                  setFieldValue('auxiliaryLine', auxiliaryLine)
                } else if (!useAuxiliaryLine) {
                  setFieldValue('auxiliaryLine', null)
                }
                handleChange(e)
              }}
              onBlur={handleBlur}
              isInvalid={!!(touched.useAuxiliaryLine && errors.useAuxiliaryLine)}
            />
          </Form.Group>
          <Form.Group as={Col} sm={3}>
            <InputGroup size='sm' hasValidation>
              <Form.Control
                type='number'
                name='auxiliaryLine.startColumn'
                value={nullishValueToValue(values.auxiliaryLine?.startColumn)}
                onChange={(e) => {
                  if (values.auxiliaryLine) {
                    const auxiliaryLine = { ...values.auxiliaryLine } as MutableAuxiliaryLine
                    auxiliaryLine.startColumn = nullishValueToInternalValue(e.target.value)
                    const newAuxiliaryLine = {
                      ...values.auxiliaryLine,
                      ...auxiliaryLine
                    }
                    console.log('newAuxiliaryLine', newAuxiliaryLine)
                    setFieldValue('auxiliaryLine', newAuxiliaryLine)
                  }
                }}
                disabled={!values.useAuxiliaryLine}
                onBlur={handleBlur}
                isInvalid={!!(touched.auxiliaryLine?.startColumn && errors.auxiliaryLine?.startColumn)}
              />
              <InputGroup.Text>段目</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors.auxiliaryLine?.startColumn}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} sm={3}>
            <InputGroup size='sm' hasValidation>
              <Form.Control
                type='number'
                name='auxiliaryLine.startRow'
                value={nullishValueToValue(values.auxiliaryLine?.startRow)}
                onChange={(e) => {
                  if (values.auxiliaryLine) {
                    const auxiliaryLine = { ...values.auxiliaryLine } as MutableAuxiliaryLine
                    auxiliaryLine.startRow = nullishValueToInternalValue(e.target.value)
                    const newAuxiliaryLine = {
                      ...values.auxiliaryLine,
                      ...auxiliaryLine
                    }
                    console.log('newAuxiliaryLine', newAuxiliaryLine)
                    setFieldValue('auxiliaryLine', newAuxiliaryLine)
                  }
                }}
                disabled={!values.useAuxiliaryLine}
                onBlur={handleBlur}
                isInvalid={!!(touched.auxiliaryLine?.startRow && errors.auxiliaryLine?.startRow)}
              />
              <InputGroup.Text>行目</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors.auxiliaryLine?.startRow}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
          <Form.Group as={Col} sm={3}>
            <InputGroup size='sm' hasValidation>
              <Form.Control
                type='number'
                name='auxiliaryLine.length'
                value={values?.auxiliaryLine?.length || ''}
                onChange={handleChange}
                disabled={!values.useAuxiliaryLine}
                onBlur={handleBlur}
                isInvalid={!!(touched.auxiliaryLine?.length && errors.auxiliaryLine?.length)}
              />
              <InputGroup.Text>段</InputGroup.Text>
              <Form.Control.Feedback type='invalid'>{errors?.auxiliaryLine?.length}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        </Row>
      </Form.Group>
    </Row>
  )
}
